<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-a-egg-f5ebdc w-full rounded-12 p-8 px-10">
                    <div class="text-center text-24 font-bold pb-14">{{lbl.register.traces_title}}</div>
                    <div class="flex relative w-full">
                        <img class="m-auto" src="@/assets/register/crown.svg" />
                        <div class="w-full h-full absolute top-0 left-0 flex">
                            <div class="mt-6 mx-auto text-22 text-white">{{point}}</div>
                        </div>
                    </div>
                    <div class="text-center text-14 pb-6 pt-14">{{getPointText()}}</div>
                    <div class="">
                        <RedButton @click="clickOk()">
                            {{lbl.register.traces_btn}}
                        </RedButton>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

import RedButton from "@/components/Button/RedButton.vue"

export default {
    name: "TracesModal",
    mixins: [LocaleMixin],
    components: {
        RedButton
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            point: 0,
            title: '',
            message: '',
            btnOk: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.point = config.point;
            this.btnOk = config.btnOk;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        getPointText: function () {
            return Util.stringFormat(this.lbl.register.traces_msg,this.point);
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
    }
</style>
